<template>
    <div class="bid-modal modal" :class="{ 'is-active': isActive }">
        <div class="modal-background"></div>
        <div class="modal-card" v-if="!showTerms">
            <header class="modal-card-head" v-if="false">
                <img :src="'/static/images/manufacturers/' +  bid.company + '.png'" style="float: left; margin-right: 10px;" width="50">
                <strong class="has-text-primary" style="padding-right: 5px;">{{ bid.company }}</strong><strong>{{ bid.model_name }}</strong>
            </header>
            <section class="modal-card-body" v-if="!groupLoadingStatus">
                <div class="theme-table-container table-container center-column">
                    <table class="auction-table theme-table table is-striped is-narrow is-hoverable is-scrollable is-fullwidth"
                           id="enquiry-table">
                        <thead>
                        <tr class="top-header" id="resultTable">
                            <th>Photo</th>
                            <th>Lot No</th>
                            <th>Date</th>
                            <th>Model</th>
                            <th>Grade</th>
                            <th>Price</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="picture-td" data-label="photo">
                                <div class="image is-64x64">
                                    <img :src="bid.pictures.split('#')[1] + '&w=320'" @error="imgUrlAlt($event)">
                                </div>
                            </td>
                            <td>{{ bid.bid }}</td>
                            <td>{{ bid.lot_date }}</td>
                            <td>{{ bid.company }} {{ bid.model_name_en }}</td>
                            <td>{{ bid.grade_en }}</td>
                            <td>{{ bid.start_price | formatNumber }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="notification is-info" v-if="false">
                    <strong>Important!</strong>
                    <ul class="is-size-7">
                        <li>
                            Sometimes we overbid up to 20,000 JPY depending on the bidding condition
                            (high competition, network speed, auction houses, rules and other).
                        </li>
                        <li>
                            "Win Max" can be changed until 8:00(JST) of the day of the auction. After 8:00(JST) please
                            contact your sales consultant.
                        </li>
                        <li>
                            By pushing "Place Bid", you accept <a v-on:click="showTerms = true">Terms & Conditions of Use.</a>
                        </li>
                    </ul>
                </div>
                <div class="notification is-danger" v-if="bidErrorStatus">
                    <p>{{ bidErrorMessage }}</p>
                </div>
                <bid-input :bid="bid"></bid-input>
                <div class="form-row-bid">
                <group-select :bid="bid"></group-select>
                <group-max-wins :bid="bid"></group-max-wins>
                </div>
                <group-remarks :bid="bid"></group-remarks>
                <inland-cost :lot="bid" :type="'modal'"></inland-cost>

                <div class="tems-condition">
                    <ul class="is-size-7">
                        <li>
                            <strong>Important!</strong> By pushing "Place Bid", you accept <a v-on:click="showTerms = true">Terms & Conditions of Use.</a>
                        </li>
                    </ul>
                </div>
            </section>
            <section class="modal-card-body" v-if="groupLoadingStatus">
                <h3>Loading...</h3>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-info" v-if="lotHasBid" @click="updateBid"  :class="{ 'is-loading': isLoading }" :disabled=isDisabled>Update Bid</button>
                <button class="button is-primary"
                        v-if="!lotHasBid && bidAllowed"
                        @click="placeBid"
                        :class="{ 'is-loading': isLoading }" :disabled="isDisabled">Place Bid</button>
                <button class="button" @click="closeBidModal()" :disabled="isLoading">Cancel</button>
                <span class="ml-10 paypal-img" @click="openModal"><img src="@/assets/paypal.png"></span>
                <span v-if="isDisabled" class="has-text-danger">{{ validation }}</span>
            </footer>
        </div>
        <div class="modal-card" style="width: 90%;" v-if="showTerms">
            <header class="modal-card-head">
                <p class="modal-card-title">Terms and Conditions</p>
            </header>
            <section class="modal-card-body">
                <terms></terms>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-primary" @click="showTerms = false">Back</button>
            </footer>
        </div>
        <div class="modal" :class="{'is-active' : isActiveP }">
            <div class="modal-background" @click="closeModal"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Transactions</p>
                    <button class="delete" aria-label="close" @click="closeModal"></button>
                </header>

                <section class="modal-card-body">
                    <p class="has-text-success" v-if="getSuccess">{{ paymentMsg }}</p>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="no-wrap">Add Deposits</label>
                        </div>
                        <div class="field-body mr-10 mbr-0">
                            <div class="field has-addons">
                                <div class="control">
                                    <input v-model="amount_yen" v-on:keyup="convertYen()" class="input" type="number" placeholder="Amount">
                                </div>
                                <p class="control">
                                    <a class="button is-static">
                                        000 ¥
                                    </a>
                                </p>
                                <div class="control">
                                    <input class="input" type="number" v-on:keyup="convertUsd()" placeholder="Amount" v-model="amount_usd">
                                </div>
                                <p class="control">
                                    <a class="button is-static">
                                        $
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div class="field-submit">
                            <div ref="paypal"></div>
                        </div>
                    </div>
                    <table class="table is-striped is-narrow is-hoverable is-fullwidth">
                        <thead>
                        <tr>
                            <th>Transaction</th>
                            <th>Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td colspan="2" class="has-text-centered">Coming soon...</td>
                        </tr>
                        </tbody>
                    </table>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="closeModal">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import BidInput from './Modal/BidInput.vue'
    import Terms from './Modal/Terms.vue'
    import apiBids from '../../../api/apiBids'
    import inlandCost from '../../Tools/Calculators/InlandCost.vue'
    import GroupSelect from './Modal/GroupSelect.vue'
    import GroupMaxWins from './Modal/GroupMaxWins.vue'
    import GroupRemarks from './Modal/GroupRemarks.vue'
    import apiRates from '../../../api/apiRates'
    export default {
        props: ['bid'],
        components: {
            BidInput,
            Terms,
            inlandCost,
            GroupSelect,
            GroupMaxWins,
            GroupRemarks
        },
        data() {
            return {
                hasBid: false,
                showTerms: false,
                lotHasBid: ((this.bid.bids.length > 0 === true)),
                validation: null,
                currentBid: {
                    id: '',
                    status:  '',
                    amount_yen:  null,
                    amount_usd: null,
                    lot_id: '',
                    group: {}
                },
                modalStatus: false,
                amount_yen: '',
                amount_usd: '',
                paymentMsg: '',
                paypalClient: {
                    sandbox: 'ASqta9ZOOfiQLr_z4iniwYPJvsJ1Atk45zd82fTaI023ND8I9u5pBKvBi60QImFcob1V6dxfQBq7-qvY',
                    production: 'AaxhtJJA0nr5yaI-6GppVrCVqTCDWt_8sqGPio39eabV5HVKH2tqHBb5FX0up_GYaUwFMVG9oG-f1Kxu'
                }
            }
        },
        computed: {
            bidErrorStatus () {
                return this.$store.getters.getBidErrorStatus
            },
            bidErrorMessage () {
                return this.$store.getters.getBidErrorMessage
            },
            isActive: function () {
                return this.$store.getters.getBidModalStatus(this.bid.lot_id)
            },
            isLoading: function () {
                return this.$store.getters.getPlaceBidLoadingStatus
            },
            groupLoadingStatus() {
                return this.$store.getters.getGroupLoadingStatus
            },
            bidAllowed: function () {
                return this.$store.getters.getGroupSettings.max_groups > 0
            },
            isDisabled: function () {
                if (this.$store.getters.getCurrentBidAmountYen === null && this.$store.getters.getCurrentBidAmountUsd === null) {
                    this.validation = 'Please input bid amount.'
                    return true
                } else {
                    this.validation = null
                    return false
                }
            },
            isActiveP() {
                return this.modalStatus
            },
            getSuccess(){
                return this.$store.getters.getPaymentData
            }

        },
        methods: {
            closeBidModal() {
                this.$store.dispatch('changeCurrentBidAmountYen', '')
                this.$store.dispatch('changeCurrentBidAmountUsd', '')
                this.$store.dispatch('changeCurrentBid', this.currentBid)
                this.$store.dispatch('changeCurrentBidGroup', '')
                this.$store.dispatch('changeBidError', {field: 'status', value: false})
                this.$store.dispatch('changeBidError', {field: 'message', value:''})
                this.$store.dispatch('changePlaceBidLoadingStatus', false)
                this.$store.dispatch('changeBidModalStatus', { status: false, lotId: '' })
            },
            closeModal() {
                this.modalStatus = false
            },
            convertYen() {
                setTimeout(function () {
                    //this.$store.dispatch('changePlaceBidLoadingStatus', true)
                    const query = {amount_yen: this.amount_yen}
                    apiRates
                        .convertYenRequest(query)
                        .then((response) => {
                            this.amount_usd = response.data
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }.bind(this), 1000)
            },
            convertUsd() {
                setTimeout(function () {
                    //this.$store.dispatch('changePlaceBidLoadingStatus', true)
                    const query = { amount_usd: this.amount_usd }
                    apiRates
                        .convertUsdRequest(query)
                        .then((response) => {
                            this.amount_yen = response.data
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }.bind(this), 1000)
            },
            placeBid() {
                this.$store.dispatch('changeBidError', {field: 'status', value: false})
                this.$store.dispatch('changeBidError', {field: 'message', value:''})
                this.$store.dispatch('changePlaceBidLoadingStatus', true)
                this.$store.dispatch('changeCurrentBidGroup', this.$store.getters.getSelectedGroup)
                apiBids
                    .placeBidRequest(this.$store.getters.getCurrentBid)
                    .then((response) => {
                        if (response.status === 200){
                            this.bid.bids = [response.data]
                            this.$store.dispatch('changeCurrentBidStatus', this.$bidStatusActive)
                            this.$store.dispatch('changePlaceBidLoadingStatus', false)
                            this.closeBidModal()
                        }
                    })
                    .catch((err) => {
                        console.log(err.response)
                        this.$store.dispatch('changePlaceBidLoadingStatus', false)
                        this.$store.dispatch('changeBidError', {field: 'status', value: true})
                        this.$store.dispatch('changeBidError', {field: 'message', value: err.response.data.bid})
                    })
            },
            updateBid() {
                this.$store.dispatch('changePlaceBidLoadingStatus', true)
                this.$store.dispatch('changeBidError', {field: 'status', value: false})
                this.$store.dispatch('changeBidError', {field: 'message', value:''})
                this.$store.dispatch('changeCurrentBidGroup', this.$store.getters.getSelectedGroup)
                apiBids
                    .updateBidRequest(this.$store.getters.getCurrentBid)
                    .then((response) => {
                        this.$store.dispatch('changeCurrentBidStatus', this.$bidStatusActive)
                        this.bid.bids[0].amount_yen = this.$store.getters.getCurrentBidAmountYen
                        this.bid.bids[0].amount_usd = this.$store.getters.getCurrentBidAmountUsd
                        this.bid.bids[0].group.remarks = this.$store.getters.getCurrentBidGroupRemarks
                        this.bid.bids[0].group.name = this.$store.getters.getCurrentBid.group_name
                        this.bid.bids[0].group.id = this.$store.getters.getCurrentBid.group_id
                        this.bid.bids[0].group.max_wins = this.$store.getters.getCurrentBidGroupMaxWins
                        this.bid.bids[0].status = response.data.original.status
                        this.bid.bids[0].position = response.data.original.position
                        this.$store.dispatch('changePlaceBidLoadingStatus', false)
                        this.closeBidModal()
                    })
                    .catch((err) => {
                        console.log(err.response)
                        this.$store.dispatch('changePlaceBidLoadingStatus', false)
                        this.$store.dispatch('changeBidError', {field: 'status', value: true})
                        this.$store.dispatch('changeBidError', {field: 'message', value: err.response.data.bid})
                    })
            },
            openModal() {
                this.modalStatus = true
            },
            setLoaded: function() {
                this.loaded = true;

                window.paypal
                    .Buttons({
                        createOrder: (data, actions) => {
                            if(this.amount_usd) {
                                return actions.order.create({
                                    purchase_units: [
                                        {
                                            description: 'Deposits in UNET',
                                            amount: {
                                                currency_code: "USD",
                                                value: this.amount_usd
                                            }
                                        }
                                    ]
                                });
                            }
                        },
                        onApprove: async (data, actions) => {
                            const order = await actions.order.capture();
                            if(order){
                                this.$store.dispatch('payment', order);

                                this.amount_usd = '';
                                this.amount_yen = '';
                                this.paymentMsg = 'Payment Successful';
                                console.log(order);
                            }
                        },
                        onError: err => {
                            console.log(err);
                        }
                    })
                    .render(this.$refs.paypal);
            }
        },
        created() {
            const script = document.createElement("script");
            script.src =
                "https://www.paypal.com/sdk/js?disable-funding=credit,card&client-id="+this.paypalClient.production;
            script.addEventListener("load", this.setLoaded);
            document.body.appendChild(script);
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Lot/BidModal.vue